import { Check } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel, GoldButton } from "@/components/ui-kit";
import { PageHero, FinalCTA, ScheduleTable } from "@/components/blocks";
import { images } from "@/data/site";

const approach = ["valutazione iniziale", "programmazione individuale", "monitoraggio del percorso", "coaching", "supporto tecnico", "attenzione alla corretta esecuzione", "obiettivi realistici e progressivi"];
const goals = ["dimagrimento", "tonificazione", "aumento massa muscolare", "forza", "ricomposizione corporea", "postura", "recupero forma fisica", "preparazione atletica"];
const coverage = [{ days: "Lunedì - Venerdì", time: "6:30 - 23:00" }, { days: "Sabato", time: "8:30 - 18:30" }];

export default function SalaPesi() {
  return (
    <>
      <Seo title="Sala Pesi a Lusciano | Body Evolution 2.0" description="Allenati nella sala pesi di Body Evolution 2.0 con attrezzi, macchinari, pesi, istruttori e percorsi personalizzati." />
      <PageHero label="Sala Pesi" title="Sala pesi, attrezzi e coaching per il tuo percorso"
        subtitle="Non ti diamo solo una scheda. Ti costruiamo un percorso." image={images.weightRoom}
        text="La sala pesi di Body Evolution 2.0 è pensata per chi vuole allenarsi con metodo, sicurezza e continuità. Attrezzi, macchinari e pesi sono a disposizione in un ambiente ampio e organizzato, con il supporto di istruttori e personal trainer dedicati." />

      <section className="bg-ivory py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-16">
          <div>
            <Reveal><SectionLabel>Il nostro approccio</SectionLabel></Reveal>
            <Reveal delay={0.1}><h2 className="mt-6 font-display font-medium tracking-tight text-3xl lg:text-4xl text-ink-800">Un percorso, non solo una scheda</h2></Reveal>
            <Reveal delay={0.2}><p className="mt-5 text-ink-800/70 leading-relaxed">Ogni cliente entra in una linea di lavoro specifica, costruita sulle proprie esigenze. Il concetto non è la semplice scheda di allenamento, ma un percorso personalizzato, monitorato e aggiornato in base agli obiettivi.</p></Reveal>
            <div className="mt-8 space-y-3">
              {approach.map((a, i) => (
                <Reveal key={a} delay={0.05 * i}>
                  <div className="flex items-center gap-3 text-ink-800/80"><Check size={18} className="text-gold shrink-0" /><span className="capitalize">{a}</span></div>
                </Reveal>
              ))}
            </div>
          </div>
          <div>
            <Reveal><SectionLabel>Copertura istruttori</SectionLabel></Reveal>
            <Reveal delay={0.1}><div className="mt-6"><ScheduleTable schedule={coverage} /></div></Reveal>
            <Reveal delay={0.15}><div className="label text-gold mt-12">Obiettivi che seguiamo</div></Reveal>
            <div className="mt-5 flex flex-wrap gap-2.5">
              {goals.map((g, i) => (
                <Reveal key={g} delay={0.03 * i}>
                  <span className="px-4 py-2 rounded-full bg-white border border-black/10 text-sm text-ink-800/80 capitalize">{g}</span>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}><div className="mt-10"><GoldButton to="/contatti">Inizia il tuo percorso</GoldButton></div></Reveal>
          </div>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
